import { Middleware } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

import * as actions from '../api'

const api: Middleware<{}> =
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    if (action.type !== actions.apiCallBegan.type) return next(action)

    const headers = { authorization: '', 'Accept-Language': 'fa' }

    let appToken: string = getState().auth.appToken
    const language: string = getState().ui.language
    if (getState().auth.appToken !== null && getState().auth.token === null) {
      appToken = getState().auth.appToken
    } else {
      appToken = getState().auth.token
    }

    headers.authorization = `Bearer ${appToken}`
    // headers.language = language

    try {
      dispatch({ type: action.payload.onStart })
      const response = await axios.request({
        baseURL: action.payload.baseURL,
        data: action.payload.data,
        method: action.payload.method,
        params: action.payload.params,
        url: action.payload.url,
        headers,
      })
      dispatch({ type: action.payload.onSuccess, payload: response.data })
    } catch (error: any) {
      dispatch({ type: action.payload.onError, payload: error.response.data })
    }
  }

export default api
